import React from 'react'
import {PulseBox, PulseCircle, PulseLine} from "../../../components/EmptyHolder/helpers";


const OrganizationExplorerLoading = () => {
    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 16, padding: '8px 0'}}>

            {/* WorkingApp card */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 24,
                overflow: 'hidden',
                border: '1px solid #f0f0f0'
            }}>

                {/* Cover photo */}
                <PulseBox height={160} borderRadius={0}/>

                {/* User info + navigator */}
                <div style={{padding: '14px 16px 16px', display: 'flex', flexDirection: 'column', gap: 14}}>

                    {/* Avatar + name + badge */}
                    <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
                        <PulseCircle size={44}/>
                        <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: 6}}>
                            <PulseLine width="70%" height={16}/>
                            <PulseLine width="45%" height={11}/>
                            <PulseLine width="55%" height={11}/>
                        </div>
                        <PulseBox width={58} height={26} borderRadius={20}/>
                    </div>

                    {/* Navigator grid 3x2 */}
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12}}>
                        {[0, 1, 2, 3, 4, 5].map(i => (
                            <div key={i}
                                 style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6}}>
                                <PulseBox width={48} height={48} borderRadius={14}/>
                                <PulseLine width={44} height={10}/>
                            </div>
                        ))}
                    </div>

                </div>
            </div>

            {/* Recent organizations */}
            <div style={{
                padding: 16,
                display: 'flex',
                flexDirection: 'column',
                gap: 12,
                borderRadius: 24,
                border: '1px solid #f0f0f0'
            }}>
                <div style={{display: 'flex', flexDirection: 'column', gap: 6}}>
                    <PulseLine width={160} height={13}/>
                    <PulseBox width={32} height={3} borderRadius={4}/>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', gap: 10, overflow: 'hidden'}}>
                    {[0, 1, 2, 3, 4].map(i => (
                        <PulseBox key={i} width={48} height={48} borderRadius={14}/>
                    ))}
                </div>
            </div>

            {/* Current courses */}
            <div style={{
                padding: 12,
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                borderRadius: 24,
                border: '1px solid #f0f0f0'
            }}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, marginBottom: 4}}>
                    <PulseLine width={160} height={20}/>
                    <PulseBox width={64} height={3} borderRadius={4}/>
                </div>
                {[0, 1].map(i => (
                    <div key={i} style={{
                        display: 'flex',
                        gap: 12,
                        alignItems: 'center',
                        padding: 12,
                        borderRadius: 18,
                        background: '#f5f5f5'
                    }}>
                        <PulseBox width={56} height={56} borderRadius={12}/>
                        <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: 6}}>
                            <PulseLine width="80%" height={13}/>
                            <PulseLine width="55%" height={11}/>
                            <PulseLine width="65%" height={11}/>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    )
}


export default OrganizationExplorerLoading
